import { render } from "./Personal.vue?vue&type=template&id=127b1b00&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"

import "@/assets/iconfont.css?vue&type=style&index=0&id=127b1b00&scoped=true&lang=css"
import "./Personal.vue?vue&type=style&index=1&id=127b1b00&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127b1b00"]])

export default __exports__